define.alias("shared/components/shared/post/secondary/hashtag-suggestions/error", "media/components/shared/post/secondary/hashtag-suggestions/error");